import { render, staticRenderFns } from "./WarehouseAreaEdit.vue?vue&type=template&id=68aaef8f&"
import script from "./WarehouseAreaEdit.vue?vue&type=script&lang=js&"
export * from "./WarehouseAreaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports